<script>
	import LmsContentOverview from "./content/LmsContentOverview.svelte";
	import LmsStatsOverview from "./overview/LmsStatsOverview.svelte";
	import {External, M} from "../../external";
  import { onMount } from 'svelte';

	export let entity, circleDetails = {}, activePeriod = {}, type = "CIRCLE", tabSelected = "overview", showTabs = true, productIds = [], style = {};

</script>
<div class="sections-wrapper profile-inner-wrapper bg-white" class:box-shadow={style.shadow} style="overflow:hidden;">
	<div class="col20 f-left">
		{#if showTabs}
			<div class="upper-navigation upper-navigation-full mt-15">
				<ul>
					<li on:click={() => tabSelected = 'overview'}><a class:active={tabSelected === 'overview'}>{M.OVERVIEW}</a></li>
					<li on:click={() => tabSelected = 'content'}><a class:active={tabSelected === 'content'}>{M.CONTENT}</a>
				</ul>
			</div>
		{/if}
		<div class="col20 f-left">
			{#if tabSelected === 'overview'}
				{#key activePeriod || entity}
					<LmsStatsOverview
						circleDetails={circleDetails}
						entity={entity}
						activePeriod={activePeriod}
						type={type}
						productIds={productIds}
					/>
				{/key}
			{:else if tabSelected === 'content'}
				{#key entity}
					<LmsContentOverview circle={circleDetails?.circle} activePeriod={activePeriod}/>
				{/key}
			{/if}
		</div>
	</div>
</div>
